import { queryKeys } from "../queryKeys";
import { type AcatsTransfer, getAcatsTransferDetails } from "../rest/acats";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAcatsTransferDetails = ({
  accountId,
  acatsId,
  options,
}: {
  accountId: string;
  acatsId: string;
  options?: QueryOptions<AcatsTransfer>;
}) => {
  const res = useRequest(
    queryKeys.acats.transferDetails(accountId, acatsId),
    () => getAcatsTransferDetails(accountId, acatsId),
    options,
  );
  return res;
};
